"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.CsearchAPI = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var CsearchAPI = /*#__PURE__*/function () {
  function CsearchAPI() {
    (0, _classCallCheck2["default"])(this, CsearchAPI);
  }
  (0, _createClass2["default"])(CsearchAPI, null, [{
    key: "getCatalogs",
    value: function getCatalogs() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, "jCatalogs", {}, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getModels",
    value: function getModels(catalog) {
      var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        model: model,
        search: search,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, "jModelsDt", params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getArticles",
    value: function getArticles(catalog, cmodel) {
      var variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        cModel: cmodel,
        datalimits: 0,
        Variant: variant || ''
      };
      _NextApiClient.NextApiClient.com(this.service, 'jTipDt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getItemTip",
    value: function getItemTip(catalog, model, tip) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        cModel: model,
        tip: tip,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, 'jItemTipDt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "searchItem",
    value: function searchItem(catalog, model, search) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        Catalogo: catalog,
        model: model,
        search: search,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, 'jItemSearchDt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "authSearch",
    value: function authSearch(_ref) {
      var table = _ref.table,
        _ref$page = _ref.page,
        page = _ref$page === void 0 ? 1 : _ref$page,
        _ref$rows = _ref.rows,
        rows = _ref$rows === void 0 ? -1 : _ref$rows,
        _ref$order = _ref.order,
        order = _ref$order === void 0 ? 0 : _ref$order,
        _ref$where = _ref.where,
        where = _ref$where === void 0 ? '' : _ref$where;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        auth: table,
        Page: page,
        Rows: rows,
        cOrder: order,
        cWhere: where
      };
      _NextApiClient.NextApiClient.com(this.service, 'AuthSearch', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "itemSearchDt",
    value: function itemSearchDt(search, _ref2) {
      var catalog = _ref2.catalog,
        model = _ref2.model;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        search: search,
        Catalogo: catalog,
        model: model,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, 'jItemSearchDt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "itemSearchExt",
    value: function itemSearchExt(search, _ref3) {
      var catalog = _ref3.catalog,
        model = _ref3.model,
        tip = _ref3.tip;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        search: search,
        Catalogo: catalog,
        model: model,
        tip: tip,
        datalimits: 0
      };
      _NextApiClient.NextApiClient.com(this.service, 'jItemSearchDtExt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }]);
  return CsearchAPI;
}();
exports.CsearchAPI = CsearchAPI;
CsearchAPI.service = 'CSearch';
//# sourceMappingURL=CsearchAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/CsearchAPI.js
// module id = 1217
// module chunks = 142